import axiosIns from "@/libs/axios";

export function requestLoadSamples(reqData) {
    return axiosIns.post("/admin/list_samples", reqData, {});
}
